import { render } from "./HorizontalNavMenuLink.vue?vue&type=template&id=a3ad6350"
import script from "./HorizontalNavMenuLink.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__